export default __webpack_public_path__ + "static/media/docplaceholder.3801c20f.jpeg";